import Table from "@components/Table";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import PieChart from "../PieChart";
import * as styles from "./TableWithPieChart.css";
import type { Props } from "./types";

export default function TableWithPieChart({
	data,
	pieData,
	headers,
	colors,
	chartPosition,
	className,
	size,
}: Props & styles.LayoutVariants) {
	const cellRenderer = (value: unknown, [row, col]: [number, number]) => {
		if (col > 0) {
			return value as string;
		}
		return (
			<span
				className={styles.legend}
				style={assignInlineVars({
					[styles.legendColor]: `${colors[row] ?? "black"}`,
				})}
			>
				{value as string}
			</span>
		);
	};

	return (
		<div className={`${styles.layout({ chartPosition })} ${className}`}>
			<div className={styles.slot({ name: "table" })}>
				<Table
					data={data}
					headers={headers}
					renderCell={cellRenderer}
					className={styles.table}
				/>
			</div>
			<div className={styles.slot({ name: "chart" })}>
				<PieChart data={pieData} colors={colors} size={size} />
			</div>
		</div>
	);
}
